// extracted by mini-css-extract-plugin
export default {"image":"q1-z","loaded":"r1-z"};